export function MediamarktTermsDE() {
  return (
    <article>
      <h1>Geschäftsbedingungen</h1>

      <time dateTime="2024-09-01">September 2024</time>

      <div>
        <h3>1. Allgemeines</h3>
        <p>
          Jotta AS („Jottacloud“) bietet einen Cloud-Speicherdienst („Dienst“)
          an, mit dem Sie Dateien über das Internet speichern, sichern,
          synchronisieren und freigeben können. Diese Servicebedingungen
          („Vereinbarung“) bilden zusammen mit unserer Datenschutzrichtlinie
          eine rechtlich bindende Vereinbarung zwischen Jottacloud und Ihnen als
          Benutzer. Verweise auf „wir“, „unser“ und „uns“ beziehen sich auf
          Jottacloud, während sich „Sie“, „Ihr“ und „Benutzer“ auf den Benutzer
          beziehen. Durch die Nutzung des Dienstes stimmen Sie den Bedingungen
          dieser Vereinbarung zu und sind an diese gebunden.
        </p>
        <h3>2. Benutzerkonto</h3>
        <p>
          Um den Dienst nutzen zu können, müssen Sie ein Jottacloud-Konto
          einrichten. Die verfügbaren Abonnementpläne sind in der Preis- und
          Abonnementübersicht von Jottacloud beschrieben. Im Allgemeinen
          umfassen die Abonnementtypen ein kostenloses Konto, ein persönliches
          Konto für einen Benutzer, ein persönliches Konto für mehrere Benutzer
          und ein Geschäftskonto.
        </p>
        <h3>3. Kostenloses Konto</h3>
        <p>
          Ein kostenloses Konto wird kostenlos mit bestimmten Einschränkungen
          hinsichtlich Speicherkapazität und Funktionen bereitgestellt.
          Jottacloud behält sich außerdem das Recht vor, andere Einschränkungen
          anzuwenden und bezahlte Werbung auf kostenlosen Konten anzuzeigen. Ein
          kostenloses Konto kann vonseiten Jottaclouds gekündigt werden, wenn es
          für einen Zeitraum von einem Jahr oder länger inaktiv war.
        </p>
        <h3>4. Persönliches Konto für einen oder mehrere Benutzer</h3>
        <p>
          Ein persönliches Konto für einen oder mehrere Benutzer ist
          ausschließlich für die individuelle private Nutzung und nicht für
          Unternehmen, Organisationen oder ähnliche Einrichtungen verfügbar. Ein
          persönliches Konto für einen oder mehrere Benutzer kann nicht zum
          Speichern von Daten in einem kommerziellen Kontext verwendet werden
          und verfügt über Speicherkapazitäten und Funktionen gemäß dem
          gewählten Abonnement. Für persönliche Konten werden Abonnements für
          einen einzelnen Benutzer sowie gemeinsam nutzbare Abonnements für bis
          zu fünf Benutzer angeboten.
        </p>
        <p>
          Ein persönliches Konto für einen oder mehrere Benutzer hat eine
          Laufzeit von einem bzw. zwölf Monaten und verlängert sich automatisch
          um einen weiteren Abonnementzeitraum (einen Monat bzw. zwölf Monate),
          sofern der Benutzer das kostenpflichtige Abonnement nicht vor Ablauf
          des aktuellen Abonnementzeitraums kündigt. Die Kreditkarte des
          Benutzers wird automatisch belastet, wenn ein Abonnement verlängert
          wird. Zahlungen sind bei einer Kündigung nicht erstattungsfähig. Der
          Benutzer kann sein Abonnement jederzeit kündigen oder ändern. Bei
          Einrichtung eines persönlichen Kontos mit mehreren Benutzern wird
          automatisch ein Administrator erstellt.
        </p>
        <p>
          Der Administrator ist für das Hinzufügen und Verwalten des Abonnements
          und seiner Mitglieder verantwortlich. Der Administrator erkennt
          einzelne Mitglieder des Abonnements mittels einer angegebenen
          E-Mail-Adresse oder Handynummer.
        </p>
        <p>
          Ein Administrator kann ein Konto jederzeit hochstufen (Speicherplatz
          oder Mitglieder hinzufügen) oder herabstufen (Speicherplatz entfernen
          oder die Anzahl der Mitglieder verringern) oder die Abonnementlaufzeit
          ändern. Der Administrator kann ein persönliches Konto für mehrere
          Benutzer jederzeit kündigen. Bei einer Kündigung werden alle
          gespeicherten Daten innerhalb von 90 Tagen nach dem Kündigungsdatum
          gelöscht.
        </p>
        <p>
          Ein Administrator kann ein Konto jederzeit hochstufen (Speicherplatz
          oder Mitglieder hinzufügen) oder herabstufen (Speicherplatz entfernen
          oder die Anzahl der Mitglieder verringern) oder die Abonnementlaufzeit
          ändern. Der Administrator kann ein persönliches Konto für mehrere
          Benutzer jederzeit kündigen. Bei einer Kündigung werden alle
          gespeicherten Daten innerhalb von 90 Tagen nach dem Kündigungsdatum
          gelöscht.
        </p>
        <h3>5. Geschäftskonto</h3>
        <p>
          Ein Unternehmen, eine Organisation oder eine Einzelperson kann ein
          Geschäftskonto erstellen. Bei Einrichtung eines Geschäftskontos wird
          automatisch ein Geschäftskonto-Administrator erstellt. Der
          Geschäftskonto-Administrator ist für das Hinzufügen und Verwalten des
          Geschäftskontos und seiner Mitglieder verantwortlich. Für
          Geschäftskonten gelten besondere Bedingungen, siehe unten Abschnitt 6.
        </p>
        <h3>6. Besondere Bedingungen für Geschäftskonten</h3>
        <p>
          Wenn Sie ein Geschäftskonto besitzen, gilt dieser Abschnitt (Besondere
          Bedingungen für Geschäftskonten) für Ihre Nutzung des Dienstes. Ein
          Geschäftskonto wird von einem Geschäftskonto-Administrator
          („Administrator“) eingerichtet, der die Art des Geschäftsabonnements
          auswählt, Geschäftskontomitglieder („Mitglieder“) zum Konto hinzufügt
          und für jedes Mitglied ein Einzelkonto erstellt.
        </p>
        <p>
          Der Administrator erkennt die einzelnen Mitglieder des Geschäftskontos
          mittels einer angegebenen E-Mail-Adresse. Als Administrator sind Sie
          für die Zahlung der Gebühren für die Nutzung des Geschäftskontos durch
          alle Mitglieder verantwortlich. Der Administrator hat die
          ausschließliche Kontrolle über die Verwaltung aller Mitgliedskonten
          und stellt sicher, dass die gesamte Nutzung des Dienstes dieser
          Vereinbarung und anderen Anweisungen von Jottacloud entspricht. Es
          liegt in der alleinigen Verantwortung des Administrators,
          sicherzustellen, dass die Speicherkapazität für die Mitglieder nach
          Bedarf erhöht oder reduziert wird. Der Administrator ist auch dafür
          verantwortlich, nach Bedarf Einzelkonten hinzuzufügen oder zu
          entfernen. Für Geschäftskonten kann kein Bonusspeicher erworben
          werden.
        </p>
        <p>
          Der Administrator hat nur Zugriff auf die in den Konten der Mitglieder
          gespeicherten Daten, wenn diese Daten mit dem Administrator geteilt
          wurden. Der Administrator kann die Aktivitäten auf den Konten der
          Mitglieder einsehen und somit Datei- und Ordnernamen mit hochgeladenen
          Dateien und andere Kontoaktivitätsdetails lesen. Mitglieder haben nur
          Zugriff auf ihre eigenen Dateien. Mitglieder können sich untereinander
          Zugriff auf ihre Daten und Dateien geben. Das Geschäftsabonnement wird
          automatisch monatlich oder jährlich verlängert, je nach Wahl des
          Administrators. Ein Administrator kann das Konto jederzeit hochstufen
          (Speicherplatz oder Anzahl der Konten hinzufügen) oder herabstufen
          (Speicherplatz entfernen oder Anzahl der Konten verringern) oder den
          Abonnementzeitraum ändern. Derlei Änderungen gelten ab dem Ende des
          aktuellen Abonnementzeitraums. Der Administrator kann ein
          Geschäftskonto jederzeit kündigen. Bei einer Kündigung werden alle
          gespeicherten Daten gelöscht.
        </p>
        <h3>7. Lizenz zur Nutzung des Dienstes</h3>
        <p>
          Nachdem ein Benutzer gemäß der Lizenzbedingungen und Anweisungen von
          Jottacloud ein Konto eröffnet hat, gewährt Jottacloud dem Benutzer das
          Recht, den Dienst zu nutzen.
        </p>
        <p>
          Der Benutzer darf den Dienst nur im Rahmen des von Jottacloud
          bereitgestellten Zwecks und mit den von Jottacloud bereitgestellten
          Einschränkungen und Anweisungen nutzen. Jottacloud gewährt Ihnen eine
          nicht exklusive, nicht übertragbare Lizenz zur Installation und
          Nutzung des Dienstes für den angegebenen Zweck. Die Lizenz darf nicht
          auf andere Personen übertragen oder anderen über das in dieser
          Vereinbarung Beschriebene hinaus anderweitig zur Verfügung gestellt
          werden.
        </p>
        <p>
          Mit dem Dienst wird mitunter Quellcode bereitgestellt, der Eigentum
          Dritter ist und den geltenden Lizenzen Dritter unterliegt. Der Dienst
          und seine Struktur, seine Organisation, sein Quellcode und seine
          Dokumentation enthalten Geschäftsgeheimnisse.
        </p>
        <p>
          Jottacloud ist der alleinige Eigentümer des Dienstes und der zur
          Bereitstellung des Dienstes verwendeten Software sowie aller
          zugehörigen Dokumentation.
        </p>
        <p>
          Der Dienst ermöglicht es dem Benutzer, digitale Inhalte mit anderen zu
          teilen, zu senden und auszutauschen. Der Benutzer muss über alle
          erforderlichen Rechte verfügen, um diese digitalen Inhalte zu
          verteilen. Durch die Nutzung des Dienstes erkennen Sie an, dass
          Jottacloud keine Kontrolle über die digitalen Inhalte hat, die über
          den Dienst gesendet oder mit diesem Dienst verwendet werden, und dass
          Jottacloud in keiner Weise für die Nutzung, den Inhalt oder die
          Speicherung dieser digitalen Inhalte verantwortlich gemacht werden
          kann.
        </p>
        <p>
          Jottacloud hält sich jederzeit an geltendes norwegisches Recht und
          behält sich das Recht vor, Material zu entfernen oder andere
          Beschränkungen aufzuerlegen, die als notwendig erachtet werden, um die
          Einhaltung geltender Gesetze und Vorschriften sicherzustellen.
        </p>
        <p>
          Jottacloud behält sich das Recht vor, Virenprüfungen durchzuführen und
          kann das Hochladen bestimmter Dateien blockieren.
        </p>
        <p>
          Der Benutzer darf den Dienst nicht kommerziell nutzen, einschließlich,
          aber nicht beschränkt auf den Verkauf oder die Verteilung des
          Dienstes, der Software oder der Dokumentation an Dritte.
        </p>
        <h3>8. Abonnement hoch- und herabstufen</h3>
        <p>
          Sie können ein kostenloses Konto auf ein persönliches Konto oder ein
          Home-Abonnement hochstufen, indem Sie die Upgrade-Verfahren von
          Jottacloud befolgen. Ebenso können Sie ein persönliches Konto oder ein
          Home-Abonnement auf ein kostenloses Konto herabstufen. Ein Konto
          herabzustufen bedeutet, von einem persönlichen Konto oder einem
          Home-Abonnement auf ein kostenloses Konto zu wechseln. Bevor Sie eine
          derartige Herabstufung durchführen können, müssen Sie Dateien aus
          Ihrem persönlichen Konto oder Home-Abonnement löschen, damit die
          Gesamtdatenmenge das aktuelle Speicherlimit für ein kostenloses Konto
          nicht überschreitet. Bei Familienkonten müssen Sie alle anderen
          Mitglieder entfernen, bevor Sie auf ein Einzelkonto oder kostenloses
          Konto herabstufen können.
        </p>
        <h3>9. Abonnements verlängern, beenden und kündigen</h3>
        <p>
          Abonnements für persönliche Konten, Home-Abonnements und
          Geschäftskonten werden automatisch verlängert, wenn ein
          Abonnementzeitraum abläuft. Der Benutzer kann das Abonnement jederzeit
          kündigen. Wenn ein Abonnement gekündigt wird, bedeutet dies, dass es
          nach Ablauf des aktuellen Abonnementzeitraums nicht verlängert wird.
          Nach der Kündigung eines Abonnements kündigt Jottacloud entweder das
          Konto des Benutzers oder stuft das Konto des Benutzers auf ein
          kostenloses Konto herab. Wenn das Konto mehr als das aktuelle
          Speicherlimit für ein kostenloses Konto enthält, werden bei dieser
          Herabstufung alle Dateien im Konto gelöscht. Sie können Ihr
          Benutzerkonto jederzeit löschen. Dies ist in den Einstellungen auf der
          Seite „Konto und Profil“ möglich. Wenn der Benutzer Gebühren oder
          andere an Jottacloud geschuldete Beträge nicht bezahlt, hat Jottacloud
          das Recht, das Konto 90 Tage nach der ursprünglichen Zahlungsfrist zu
          kündigen. Ein auf dieser Grundlage gekündigtes Abonnement kann von
          Jottacloud nach einer Kündigungsfrist gekündigt werden, was bedeutet,
          dass Dateien und Daten gelöscht werden. Jottacloud hat das Recht, das
          Konto des Benutzers zu kündigen, wenn der Benutzer in einer Weise
          handelt, die nicht mit dieser Vereinbarung oder den von Jottacloud
          erteilten Anweisungen übereinstimmt. Wir löschen Benutzerdaten
          innerhalb von 90 Tagen nach der Kündigung des Benutzerkontos.
        </p>
        <h3>10. Mindestalter</h3>
        <p>
          Das Mindestalter für die Erstellung eines kostenlosen Kontos,
          Einzelkontos oder Familienkontos beträgt 13 Jahre. Jottacloud hat das
          Recht, alle Informationen, einschließlich des Benutzerkontos, der
          Daten und Dateien, zu löschen, wenn sich herausstellt, dass der
          Benutzer, der das Konto erstellt hat, unter 13 Jahre alt ist. Bei
          Familienkonten muss der Familienadministrator über 13 Jahre alt sein.
        </p>
        <h3>11. Änderungen an persönlichen Angaben</h3>
        <p>
          Der Nutzer muss Jottacloud bei Änderung seiner E-Mail-Adresse und
          Zahlungsinformationen unverzüglich informieren, indem er die
          Kontoeinstellungen unter „Einstellungen“ aktualisiert. Der Nutzer
          übernimmt alle Kosten, die durch falsche oder fehlende
          Aktualisierungen seiner Angaben entstehen können.
        </p>
        <h3>12. Datenschutz und Datenerfassung</h3>
        <p>
          Jottacloud kann nicht-personenbezogene Daten im Zusammenhang mit der
          Nutzung des Dienstes sammeln. Dazu gehören Statistiken und
          Leistungsmessungen im Zusammenhang mit der Software. Diese
          Informationen werden an Jottacloud gesendet und dürfen von Jottacloud
          nur gemäß den Datenschutzrichtlinien von Jottacloud verwendet werden.
          Wenn ein gültiger Gerichtsbeschluss eines norwegischen Gerichts
          vorliegt, gibt Jottacloud die Daten gemäß diesem Gerichtsbeschluss
          frei. Jottacloud wird den Benutzer in derlei Fällen benachrichtigen,
          sofern gesetzlich zulässig.
        </p>
        <h3>13. Bonus-Speicherplatz</h3>
        <p>
          Sie können zusätzlichen kostenlosen Speicherplatz
          („Bonus-Speicherplatz“) auf Ihrem Konto verdienen. Bonus-Speicherplatz
          ist kostenloser Speicherplatz, der für einen begrenzten Zeitraum auf
          Ihrem Benutzerkonto verfügbar ist. Bonus-Speicherplatz wird nur für
          kostenlose Konten und Einzelkonten angeboten. Jottacloud behält sich
          das Recht vor, die Bedingungen des Bonus-Speicherplatzes zu kündigen
          oder zu ändern.
        </p>
        <h3>14. Anforderungen für die Nutzung des Diensts</h3>
        <p>
          Um den Dienst nutzen zu können, benötigen Sie einen kompatiblen
          Computer und/oder ein Mobilgerät mit Internetzugang. Wenn Sie den
          Dienst über eine drahtlose Verbindung nutzen, könnten zusätzliche
          Kosten bei Ihrem Mobilfunkanbieter anfallen. Sie sind für die Zahlung
          aller Datenkosten sowie aller Geräte und anderer Dienste von
          Drittanbietern verantwortlich, die Sie für den Zugriff auf den Dienst
          verwenden.
        </p>
        <p>
          Der Benutzer ist dafür verantwortlich, sich sein Passwort zu merken
          und es vertraulich zu behandeln. Der Benutzer ist für alle Aktivitäten
          verantwortlich, die unter seinem Benutzernamen stattfinden. Wenn der
          Benutzer das Passwort für sein Konto verliert, besteht das Risiko,
          dass er nicht auf seine Daten zugreifen kann. Benutzername und
          Passwort des Benutzers sind persönlich und dürfen nicht an Dritte
          weitergegeben werden. Wenn der Benutzer Kenntnis von einem Missbrauch
          seines Kontos erhält, muss er Jottacloud unverzüglich benachrichtigen.
        </p>
        <h3>15. Faire und akzeptable Nutzung</h3>
        <p>
          Die Nutzung der Produkte und Dienste von Jottacloud muss den in dieser
          Vereinbarung beschriebenen Grundsätzen sowie den geltenden Gesetzen
          und Vorschriften entsprechen. Jottacloud kann Betriebsroutinen
          einrichten oder erweitern, um die Verfügbarkeit des Dienstes
          sicherzustellen und Missbrauch zu verhindern.
        </p>
        <p>
          Im Rahmen dieser Betriebsroutinen behalten wir uns das Recht vor,
          unsere Systeme zu überwachen, um eine übermäßige Nutzung von Speicher-
          und Netzwerkressourcen zu erkennen und technische und andere Maßnahmen
          zu ergreifen, die wir für notwendig erachten. Beschränkungen der
          Bandbreite und der Anzahl der API-Aufrufe können implementiert werden.
        </p>
        <p>
          Das persönliche Abonnement von Jottacloud mit unbegrenztem
          Speicherplatz soll dem Kunden Vorhersehbarkeit bieten. Die Bezeichnung
          „unbegrenzt“ bezieht sich auf den verfügbaren Speicherplatz.
        </p>
        <p>
          Benutzer mit einem persönlichen Konto oder einem Home-Abonnement
          können den Dienst für normale nichtkommerzielle Zwecke verwenden. Wir
          behalten uns das Recht vor, eine übermäßige Nutzung und einen
          Missbrauch des Dienstes zu verhindern.
        </p>
        <p>
          Wenn der gesamte Speicher- und Netzwerkverbrauch eines Benutzers
          deutlich höher ist als der normale Verbrauch eines durchschnittlichen
          Jottacloud-Benutzers und/oder darauf hinweist, dass der Dienst für
          etwas anderes als den persönlichen und nicht kommerziellen Gebrauch
          verwendet wird, kann dies als Missbrauch des Dienstes angesehen
          werden.
        </p>
        <p>
          In den oben genannten Fällen behalten wir uns das Recht vor, ein
          alternatives Jotta-Abonnement anzubieten, die Kundenbeziehung zu
          beenden oder das Konto und/oder die Benutzerdaten des Benutzers zu
          löschen. Der Benutzer erhält in derlei Fällen einen Änderungsvorschlag
          oder eine Maßnahmenmitteilung von uns.
        </p>
        <p>
          Benutzer dürfen Konten oder Dienste des Kontos nicht weiterverkaufen.
          Sie dürfen ihr Passwort nicht an Dritte weitergeben und müssen es
          sicher und angemessen aufbewahren. Es verstößt gegen diese
          Vereinbarung, die Dienste und/oder Produkte von Jottacloud für
          illegale Aktivitäten zu verwenden.
        </p>
        <p>
          Sie dürfen auf dem Dienst keine Daten speichern und/oder verteilen,
          die gegen norwegische Gesetze und Vorschriften verstoßen,
          einschließlich Datenschutz- und Urheberrechtsgesetze. Hierzu gehören
          Kinderpornografie, Raubkopien und/oder anderes illegales oder
          urheberrechtlich geschütztes Material.
        </p>
        <p>
          Benutzerkonten, die zum Speichern und/oder Teilen illegaler oder
          urheberrechtlich geschützter Materialien auf dem Dienst verwendet
          werden, werden gekündigt. Jottacloud behält sich das Recht vor, den
          Zugriff auf den Dienst zu sperren oder die Nutzung des Dienstes zu
          verbieten, Benutzerdaten zu löschen und/oder Benutzerkonten zu
          löschen, wenn wir der Ansicht sind, dass der Benutzer gegen diese
          Vereinbarung verstößt.
        </p>
        <p>
          Die Speicherung und/oder Verbreitung von Daten, die gegen norwegisches
          Recht verstoßen, kann den Behörden gemeldet werden.
        </p>
        <h3>16. Haftung und Gewährleistung</h3>
        <p>
          Die Gesamthaftung von Jottacloud für jegliche Form von Schäden, Kosten
          oder Verlusten im Zusammenhang mit dem Service, einschließlich
          Datenverlust, ist in jedem Fall auf einen Betrag beschränkt, der der
          bezahlten Gebühr für das entsprechende Konto in den letzten 12 Monaten
          vor Entstehung des Anspruchs entspricht. Jottacloud haftet nicht für
          jegliche Form von indirekten Schäden oder Folgeschäden. Diese
          Beschränkungen werden von den Parteien vereinbart und gelten, sofern
          nicht durch zwingende gesetzliche Bestimmungen etwas anderes
          vorgeschrieben ist.
        </p>
        <h3>17. Marketing und Kommunikation in elektronischen Kanälen</h3>
        <p>
          Jottacloud sendet dem Benutzer nur dann relevante und maßgeschneiderte
          Informationen über Neuigkeiten, Produkte und Dienstleistungen des
          Unternehmens über Kanäle wie E-Mail und SMS, wenn der Benutzer seine
          Zustimmung hierzu erteilt hat. Der Benutzer kann diese Zustimmung
          jederzeit widerrufen.
        </p>
        <h3>18. Änderungen am Dienst und der Vereinbarung</h3>
        <p>
          Jottacloud behält sich das Recht vor, die Bedingungen der Vereinbarung
          mit einer Frist von 30 (dreißig) Tagen zu ändern. Jottacloud behält
          sich zudem das Recht vor, den Dienst ganz oder teilweise einzustellen,
          zu ändern oder zu beenden, nachdem der Benutzer mindestens 30
          (dreißig) Tage vor einer derartigen Änderung oder Beendigung des
          Dienstes per E-Mail benachrichtigt wurde. Jottacloud behält sich des
          Weiteren das Recht vor, die Preise für laufende Abonnements zu ändern.
          Die Änderungen werden 30 (dreißig) Tage nach dem Versand der
          Benachrichtigung wirksam. Alle oben genannten Änderungsmitteilungen
          werden dem Benutzer per E-Mail zugesandt.
        </p>
        <h3>19. Kündigungsrecht</h3>
        <p>
          Der Benutzer hat nach dem Kauf des Dienstes eine Frist von 14
          (vierzehn) Tagen, um den Dienst ohne weitere Verpflichtungen vonseiten
          des Benutzers zu kündigen. Das Widerrufsrecht gilt nur für persönliche
          Konten.
        </p>
        <h3>20. Diverses</h3>
        <p>
          Jottacloud behält sich das Recht vor, diese Vereinbarung an Dritte zu
          übertragen. Jottacloud wird die Benutzer über eine derartige Änderung
          informieren. Der Benutzer wird 3 (drei) Tage im Voraus per E-Mail
          benachrichtigt.
        </p>
        <h3>21. Geltendes Recht und Streitbeilegung</h3>
        <p>
          Diese Vereinbarung unterliegt norwegischem Recht und wird
          dementsprechend ausgelegt. Der zuständige Gerichtsstand ist das
          Bezirksgericht Oslo.
        </p>
        <h3>22. Kundendienst</h3>
        <p>
          Bei Fragen zum Dienst wenden Sie sich bitte per E-Mail an den
          Kundendienst unter support@jottacloud.com. Jottacloud wird versuchen,
          alle Anfragen innerhalb eines angemessenen Zeitrahmens zu beantworten.
        </p>
        <h3>23. E-Mail-Adresse für weiterführende Informationen:</h3>
        <p>support@jottacloud.com, Jotta AS Øvre Slottsgate 5</p>
      </div>
    </article>
  )
}
